import React from "react";

const WidgetOpcionesInicio = (props) => {
    const enviarMensajeComoUsuario = (texto, handler) => {
        if (!handler || typeof handler !== "function") {
            console.error(`❌ ERROR: handler para "${texto}" no es una función válida:`, handler);
            return;
        }

        // Agregar el mensaje como si fuera del usuario
        props.setState((prevState) => ({
            ...prevState,
            messages: [
                ...prevState.messages,
                { message: texto, type: "user" },
            ],
        }));
    
        // Ejecutar el manejador pasando el mensaje como argumento
        handler(texto);
    };

    const options = [
        {
            text: "Validar domicilio / cliente",
            handler: () => enviarMensajeComoUsuario("Validar domicilio / cliente", props.actions.mostrarOpcionesValidacionCliente),
            id: 1,
        },
        {
            text: "Validar cobertura",
            handler: () => enviarMensajeComoUsuario("Validar cobertura", props.actions.iniciarValidacionCobertura),
            id: 2,
        },
        // {
        //     text: "Iniciar venta",
        //     //handler: () => enviarMensajeComoUsuario("Iniciar venta", props.actions.iniciarVenta),
        //     handler: () => enviarMensajeComoUsuario("Iniciar venta", props.actions.iniciarVentaDebug),
        //     id: 3,
        // },
        {
            text: "Ver Paquetes",
            handler: () => enviarMensajeComoUsuario("ver paquetes", props.actions.hacerConsultapaquetes),
            id: 4,
        },
        {
            text: "Consultar mis ventas",
            handler: () => enviarMensajeComoUsuario("consultar mis ventas", props.actions.hacerConsulta),
            id: 5,
        },
        
    ];

    return (
        <div className="chat-options-container">
            {options.map((option) => (
                <button
                    className="chat-option-button"
                    key={option.id}
                    onClick={option.handler}
                >
                    {option.text}
                </button>
            ))}
        </div>
    );
};

export default WidgetOpcionesInicio;
